'use strict';

/*
 * SVGeezy.js 1.0
 *
 * Copyright 2012, Ben Howdle http://twostepmedia.co.uk
 * Released under the WTFPL license
 * Original author: http://sam.zoy.org/wtfpl/
 * Browserify module adaptation: Ryan Scherler (http://eastslopestudio.com)
 */

module.exports = function (options) {
	var settings = $.extend(
		{
			avoid: false,
			filetype: 'png'
		},
		options
	);

	var plugin = {
		init: function () {
			this.avoid = settings.avoid;
			this.filetype = settings.filetype;
			this.svgSupport = plugin.supportsSvg();
			if (!this.svgSupport) {
				this.images = document.getElementsByTagName('img');
				this.imgL = this.images.length;
				this.fallbacks();
			}
		},

		fallbacks: function () {
			while (this.imgL--) {
				if (!this.hasClass(this.images[this.imgL], this.avoid) || !this.avoid) {
					var src = this.images[this.imgL].getAttribute('src');
					if (src === null) {
						continue;
					}
					if (this.getFileExt(src) == 'svg') {
						var newSrc = src.replace('.svg', '.' + this.filetype);
						this.images[this.imgL].setAttribute('src', newSrc);
					}
				}
			}
		},

		getFileExt: function (src) {
			var ext = src.split('.').pop();

			if (ext.indexOf('?') !== -1) {
				ext = ext.split('?')[0];
			}

			return ext;
		},

		hasClass: function (element, cls) {
			return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
		},

		supportsSvg: function () {
			return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
		}
	};

	return {
		on: plugin.init
	};
};
